var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePromoDiscount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4884 2.15533C10.1759 1.84274 9.75207 1.66709 9.31008 1.66699H3.33341C2.89139 1.66699 2.46746 1.84259 2.1549 2.15515C1.84234 2.46771 1.66675 2.89163 1.66675 3.33366V9.31033C1.66684 9.75232 1.8425 10.1762 2.15508 10.4887L9.40842 17.742C9.78718 18.1184 10.2995 18.3296 10.8334 18.3296C11.3674 18.3296 11.8797 18.1184 12.2584 17.742L17.7417 12.2587C18.1181 11.8799 18.3294 11.3676 18.3294 10.8337C18.3294 10.2997 18.1181 9.78742 17.7417 9.40866L10.4884 2.15533Z",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 6.66634C6.48004 6.66634 6.66659 6.47979 6.66659 6.24967C6.66659 6.01956 6.48004 5.83301 6.24992 5.83301C6.0198 5.83301 5.83325 6.01956 5.83325 6.24967C5.83325 6.47979 6.0198 6.66634 6.24992 6.66634Z",
    fill: "#DBEAFE",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePromoDiscount);
export default __webpack_public_path__ + "static/media/white-promo-discount.21b8e6d8c52e9a0f0edb9f60dd7e1071.svg";
export { ForwardRef as ReactComponent };